import { MediaPackProgram } from '@calm/evexia-web-sdk';
import { useMediaPack } from '../use-media-pack';

interface MediaPackProgramProps {
    packClass?: string;
    programId?: string;
}
export function useMediaPackProgram({
    packClass,
    programId,
}: MediaPackProgramProps) {
    const { packClass: pack, ...props } = useMediaPack(packClass);

    return {
        packProgram: pack?.items.find(
            (item): item is MediaPackProgram =>
                item.type === 'program' && item.programId === programId
        ),
        ...props,
    };
}
